export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST'
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS'
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL'
export const USER_LOGOUT = 'USER_LOGOUT'

export const USER_SCRAPBUYERADMIN_LIST_REQUEST = 'USER_SCRAPBUYERADMIN_LIST_REQUEST'
export const USER_SCRAPBUYERADMIN_LIST_SUCCESS = 'USER_SCRAPBUYERADMIN_LIST_SUCCESS'
export const USER_SCRAPBUYERADMIN_LIST_FAIL = 'USER_SCRAPBUYERADMIN_LIST_FAIL'

export const USER_SCRAPBUYERSTAFF_LIST_REQUEST = 'USER_SCRAPBUYERSTAFF_LIST_REQUEST'
export const USER_SCRAPBUYERSTAFF_LIST_SUCCESS = 'USER_SCRAPBUYERSTAFF_LIST_SUCCESS'
export const USER_SCRAPBUYERSTAFF_LIST_FAIL = 'USER_SCRAPBUYERSTAFF_LIST_FAIL'

export const USER_SCRAPSELLER_LIST_REQUEST = 'USER_SCRAPSELLER_LIST_REQUEST'
export const USER_SCRAPSELLER_LIST_SUCCESS = 'USER_SCRAPSELLER_LIST_SUCCESS'
export const USER_SCRAPSELLER_LIST_FAIL = 'USER_SCRAPSELLER_LIST_FAIL'

export const USER_SCRAPSELLER_MANAGEMENT_REQUEST = 'USER_SCRAPSELLER_MANAGEMENT_REQUEST'
export const USER_SCRAPSELLER_MANAGEMENT_SUCCESS = 'USER_SCRAPSELLER_MANAGEMENT_SUCCESS'
export const USER_SCRAPSELLER_MANAGEMENT_RESET = 'USER_SCRAPSELLER_MANAGEMENT_RESET'
export const USER_SCRAPSELLER_MANAGEMENT_FAIL = 'USER_SCRAPSELLER_MANAGEMENT_FAIL'

export const USER_SCRAPSELLER_FILTER_REQUEST = 'USER_SCRAPSELLER_FILTER_REQUEST'
export const USER_SCRAPSELLER_FILTER_SUCCESS = 'USER_SCRAPSELLER_FILTER_SUCCESS'
export const USER_SCRAPSELLER_FILTER_RESET = 'USER_SCRAPSELLER_FILTER_RESET'
export const USER_SCRAPSELLER_FILTER_FAIL = 'USER_SCRAPSELLER_FILTER_FAIL'

export const USER_SCRAPBUYERADMIN_MANAGEMENT_REQUEST = 'USER_SCRAPBUYERADMIN_MANAGEMENT_REQUEST'
export const USER_SCRAPBUYERADMIN_MANAGEMENT_SUCCESS = 'USER_SCRAPBUYERADMIN_MANAGEMENT_SUCCESS'
export const USER_SCRAPBUYERADMIN_MANAGEMENT_RESET = 'USER_SCRAPBUYERADMIN_MANAGEMENT_RESET'
export const USER_SCRAPBUYERADMIN_MANAGEMENT_FAIL = 'USER_SCRAPBUYERADMIN_MANAGEMENT_FAIL'

export const USER_SCRAPBUYERSTAFF_MANAGEMENT_REQUEST = 'USER_SCRAPBUYERSTAFF_MANAGEMENT_REQUEST'
export const USER_SCRAPBUYERSTAFF_MANAGEMENT_SUCCESS = 'USER_SCRAPBUYERSTAFF_MANAGEMENT_SUCCESS'
export const USER_SCRAPBUYERSTAFF_MANAGEMENT_RESET = 'USER_SCRAPBUYERSTAFF_MANAGEMENT_RESET'
export const USER_SCRAPBUYERSTAFF_MANAGEMENT_FAIL = 'USER_SCRAPBUYERSTAFF_MANAGEMENT_FAIL'

